import { render, staticRenderFns } from "./formBA.vue?vue&type=template&id=2bbb6b48&"
import script from "./formBA.vue?vue&type=script&lang=js&"
export * from "./formBA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports